// TODO: Partir validations.ts, cada validador por separado.
export { isValidIBAN } from "ibantools";
export {
  isDocument,
  isEmail,
  isMobilePhone,
  isNotBlank,
  isNotEmpty,
  isPhone,
  isPositiveInteger,
  isText,
} from "./validators";
export { isSpanishId, isValidCIF, isValidDNI, isValidNIE } from "./spanishId";
